import { createReducer, on } from '@ngrx/store';
import { DocumentTypeActions } from './document-type.actions';
import { DocumentTypeItem } from '@core/interface/document-type';
import { Pagination } from '@core/interface/core';

export const documentTypeFeatureKey = 'documentType';

export interface DocumentTypeState {
  documentTypes: DocumentTypeItem[];
  isLoading: boolean;
  addEditError?: any;
  pagination: Pagination;
}

export const initialState: DocumentTypeState = {
  documentTypes: [],
  isLoading: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 100,
  },
};

export const DocumentTypeReducer = createReducer(
  initialState,
  on(DocumentTypeActions.loadDocumentTypes, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(
    DocumentTypeActions.loadDocumentTypesSuccess,
    (state, { data, pagination }) => ({
      ...state,
      documentTypes: data,
      isLoading: false,
      pagination,
    })
  ),
  on(DocumentTypeActions.loadDocumentTypesFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
  })),
  on(DocumentTypeActions.addDocumentTypeSuccess, (state, { data }) => ({
    ...state,
    documentTypes: [...state.documentTypes, data],
    addEditError: null,
  })),
  on(DocumentTypeActions.addDocumentTypeFailure, (state, { error }) => ({
    ...state,
    addEditError: error,
  })),
  on(DocumentTypeActions.updateDocumentTypeSuccess, (state, { data }) => ({
    ...state,
    documentTypes: state.documentTypes.map((documentType) =>
      data.id == documentType.id ? data : documentType
    ),
    addEditError: null,
  })),
  on(DocumentTypeActions.updateDocumentTypeFailure, (state, { error }) => ({
    ...state,
    addEditError: error,
  })),

  on(DocumentTypeActions.resetDocumentType, (state) => ({
    ...state,
    documentTypes: [],
  }))
);
